export default __webpack_public_path__ + "static/media/refund-img.0b7b3bff.png";